import { render, staticRenderFns } from "./NetaListMultiAttractionComponent.vue?vue&type=template&id=31dabe8a&scoped=true&"
import script from "./NetaListMultiAttractionComponent.vue?vue&type=script&lang=js&"
export * from "./NetaListMultiAttractionComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaListMultiAttractionComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NetaListMultiAttractionComponent.vue?vue&type=style&index=1&id=31dabe8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dabe8a",
  null
  
)

export default component.exports